// extracted by mini-css-extract-plugin
module.exports = {"button":"NewFlag_button__NM7RA","eventsSelector":"NewFlag_eventsSelector__iSPzV","sponsorsLayoutBackground":"NewFlag_sponsorsLayoutBackground__2Fzut"};